import { Currency, IsoLanguageCodes } from '../types';

export const getCurrencyFromIsoLanguage = (
  isoLanguageCode: IsoLanguageCodes | null
) => {
  if (isoLanguageCode === IsoLanguageCodes.eu) {
    return Currency.GBP;
  }

  if (isoLanguageCode === IsoLanguageCodes.au) {
    return Currency.AUD;
  }

  return Currency.USD;
};

